import * as signalR from "@microsoft/signalr"
import { ref } from "vue";
import store from "@/state/store";

import { useToast } from 'vue-toastification'
const toast = useToast()
const toastOptions = {
    position: "bottom-right",
    timeout: false,
    closeOnClick: false,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: true,
    closeButton: "button",
    icon: true,
    rtl: false,
    isWs: true,
}

//TODO - testar websocket nesse projeto
const connection = ref(null)

export const notificacaoTopics =
{
    ChangedUserOrRole: "changedUserOrRole"
}

const ACTION = 'websocket/messageReceived';
const MUTATION = 'websocket/MESSAGE_RECEIVED';
const DESLOGAR_USER = 'websocket/DESLOGAR_USER';


export const actionTypes = {
    isDeslogarUser: (mutation) => {
        return mutation.type == MUTATION && 
            mutation.payload.type === DESLOGAR_USER
    }
}


var tk = () => { 
    return localStorage.getItem('ebslog.token'); 
}

export default class WsClient {

    disconnect() {
        connection.value = null
        console.log('Ws desconectado')
    }

    init() {
        if (!store.getters['account/loggedIn']) {
            console.log('Ws não iniciado. Nao autenticado')
            return
        }
        if (connection.value !=null) {
            console.log('Ws já inicializado')
            return
        }
        try {
            connection.value = new signalR.HubConnectionBuilder()
                .withUrl(process.env.VUE_APP_WSURL, { accessTokenFactory: tk })
                .build();
            this.start()
        } catch (err) {
            console.log(err);
            setTimeout(() => this.start(), 5000);
        }
    }


    async start() {
        if (connection.value.start) {
            await connection.value.start();
            if (connection.value) {
                connection.value.onclose(async () => {
                    setTimeout(this.start, 5000);
                });
                //chnaged user role read
                connection.value.on(notificacaoTopics.ChangedUserOrRole, (message) => {
                    store.dispatch(ACTION, {
                        type: DESLOGAR_USER,
                        data: JSON.parse(message)
                    })
                });
                //genric topic
                connection.value.on(notificacaoTopics.GenericTopic, (message) => {
                    const data = JSON.parse(message)
                    store.dispatch(ACTION, {
                        type: data.topic,
                        data: data
                    })

                    if (data.displayToast) {
                        const jsx = (
                            <span class="fs-sm" v-html={data.text}></span>
                        );
                        toast.info(jsx, toastOptions);
                    }
                });
            }
        }
    }
}

const wsCliente = ref(new WsClient());

function useWebsocket() {

    const disconnect = () => {
        wsCliente.value.disconnect()
    }

    const tryStart = () => {
        wsCliente.value.init();
    }

    return {
        tryStart,
        disconnect
    }
}

export {
    useWebsocket
}